module.exports = "2.6.1\n"


/*****************
 ** WEBPACK FOOTER
 ** ./version.txt
 ** module id = 334
 ** module chunks = 0
 **/